// theme.ts — bundled palette preset for the authz SPA. Shared between
// App.tsx (where it seeds the contrast-optimized boot-time default) and
// ThemePage.tsx (where it appears in the picker dropdown). Keeping a single
// source of truth means the picker's "Authz (default)" entry produces the
// same palette the SPA already shipped with.
import type { palette } from 'common'

export const AUTHZ_PRESET: palette.Preset = {
    id: 'authz',
    name: 'Authz (default)',
    description: 'Burnt-orange brand on Bootswatch Darkly / Flatly bases — the bundled authz look.',
    primaryHue: 45, // hexToOklch('#cc5500').h
    bgLight: { L: 0.985, C: 0.001, h: 0 }, // Flatly body bg ≈ #ffffff
    bgDark: { L: 0.260, C: 0.001, h: 0 },  // Darkly body bg ≈ #222222
}
